// extracted by mini-css-extract-plugin
module.exports = {"products":"styles_products__32A3e"};